import template from './providerInformationList.html';
import controller from './providerInformationListCtrl.js';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
};
